// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Container, Form, Button, Icon, Grid, Popup, Divider, Placeholder } from 'semantic-ui-react'
import fire from '../config/Fire'
import CTA from '../components/CTA'
import CustomDev from '../components/CustomDev'
import HeroWP from '../components/HeroWP'
import UserWordPress from '../components/UserWordPress'

class WordPress extends Component {
  constructor (props) {
    super(props)
    this.child = React.createRef()
    this.state = {
      edit: false,
      loading: false,
      wplink: ''
    }
  }

  techcrunch = () => {
    this.child.current.techcrunch()
  }
  wordpressAPI = () => {
    this.child.current.wordpressAPI()
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          loggedIn: true,
          loading: false,
          userUnderscore: userUnderscore
        })
        this.userData()
      } else {
        this.setState({ loggedIn: false, loading: false })
      }
    })
  }

  userData = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        if (obj.wordpressURL !== undefined) {
          this.setState({
            wplink: obj.wordpressURL
          })
          this.wordpressAPI()
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false })
      })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, edit: true })
  }

  render () {
    let { loggedIn, edit, bgColor, textColor, wplink } = this.state

    return (
      <div>
        <HeroWP />
        <Container className='masterdiv'>
          <Grid reversed='desktop' stackable className='mt' verticalAlign='top'>
            <Grid.Column width={8}>
              <Divider hidden />
              <h4 className='mt'>Enter your URL (HTTPS required)</h4>
              <Form className='mb'>
                <Form.Input
                  type='text'
                  fluid
                  onChange={this.handleChange}
                  placeholder='https://myblog.com'
                  name='wplink'
                  size='huge'
                />
                <Form.Button
                  content='Submit'
                  disabled={!edit}
                  onClick={this.wordpressAPI}
                  color='black'
                />
                {/* <Form.Button content='Try TechCrunch' onClick={this.techcrunch} color='green' /> */}
              </Form>

              <h4>Do you see an error?</h4>
              <h6>
                Some WordPress websites have security rules that prevent using the API. If you own
                the website try whitelisting murkstom.com domain on your CDN or look for API
                restriction, usually, in one of your plugins settings.
              </h6>
              {!loggedIn && <CTA />}
            </Grid.Column>
            <Grid.Column width={8}>
              <div className='newframe'>
                <UserWordPress ref={this.child} wplink={wplink} />
              </div>

              <div className='mtb'>
                <center>
                  <Popup
                    position='bottom center'
                    trigger={
                      <h5>
                        <b>
                          Experimental Preview <Icon name='exclamation triangle' color='yellow' />
                        </b>
                      </h5>
                    }>
                    Rendering of React Native components in a web browser is an experimental feature
                    and may contain issues.
                  </Popup>
                </center>
              </div>
            </Grid.Column>
          </Grid>
          <br />
          <CustomDev />
        </Container>
      </div>
    )
  }
}

export default WordPress
